/* Debellin Mega Header (Caraway-style) */
(function () {
  if (customElements.get('mega-header')) return;

  class MegaHeader extends HTMLElement {
    connectedCallback() {
      this.trigger = this.dataset.trigger || 'click';
      this.items = Array.from(this.querySelectorAll('.mh-nav__item[data-has-panel]'));
      this.current = null;
      this.mq = window.matchMedia('(min-width: 990px)');

      this.initAnnouncement();
      this.initDesktopNav();
      this.initUtilMenu();
      this.initDrawer();
      this.initSearch();
      this.initCart();
      this.initSticky();

      this.onKey = (e) => {
        if (e.key !== 'Escape') return;
        if (this.closeUtil) { const o = this.querySelector('[data-util-dd].is-open .mh-util__btn'); this.closeUtil(); o && o.focus(); }
        if (this.current) { const b = this.current.querySelector('.mh-nav__link'); this.close(); b && b.focus(); }
        if (this.classList.contains('is-drawer-open')) this.closeDrawer();
      };
      this.onDocClick = (e) => { if (this.current && !this.current.contains(e.target)) this.close(); };
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('click', this.onDocClick);
      this.mq.addEventListener && this.mq.addEventListener('change', () => { this.close(); this.closeDrawer(); });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onDocClick);
      clearInterval(this.annTimer);
    }

    /* ---------- Announcement ---------- */
    initAnnouncement() {
      const bar = this.querySelector('.mh-ann');
      if (!bar) return;
      this.slides = Array.from(bar.querySelectorAll('.mh-ann__slide'));
      this.slideIdx = 0;
      const show = (i) => {
        if (!this.slides.length) return;
        this.slideIdx = (i + this.slides.length) % this.slides.length;
        this.slides.forEach((s, n) => {
          const on = n === this.slideIdx;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) {
            bar.style.setProperty('--mh-ann-bg', s.dataset.bg || '');
            bar.style.setProperty('--mh-ann-fg', s.dataset.fg || '');
          }
        });
      };
      show(0);
      const speed = parseInt(bar.dataset.speed || '5', 10) * 1000;
      const start = () => { clearInterval(this.annTimer); if (this.slides.length > 1 && speed > 0) this.annTimer = setInterval(() => show(this.slideIdx + 1), speed); };
      const prev = bar.querySelector('[data-ann-prev]');
      const next = bar.querySelector('[data-ann-next]');
      prev && prev.addEventListener('click', () => { show(this.slideIdx - 1); start(); });
      next && next.addEventListener('click', () => { show(this.slideIdx + 1); start(); });
      bar.addEventListener('mouseenter', () => clearInterval(this.annTimer));
      bar.addEventListener('mouseleave', start);
      start();
    }

    /* ---------- Desktop mega menu ---------- */
    initDesktopNav() {
      this.items.forEach((item) => {
        const btn = item.querySelector('.mh-nav__link');
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.current === item ? this.close() : this.open(item);
        });
        if (this.trigger === 'hover') {
          item.addEventListener('mouseenter', () => {
            if (!this.mq.matches) return;
            clearTimeout(this.hoverT);
            this.hoverT = setTimeout(() => this.open(item), this.current ? 0 : 120);
          });
          item.addEventListener('mouseleave', () => {
            if (!this.mq.matches) return;
            clearTimeout(this.hoverT);
            this.hoverT = setTimeout(() => this.close(), 220);
          });
        }
      });
      const overlay = this.querySelector('.mh-overlay');
      overlay && overlay.addEventListener('click', () => this.close());
    }

    /* ---------- Dropdown menu kecil kiri atas ---------- */
    initUtilMenu() {
      this.utilItems = Array.from(this.querySelectorAll('[data-util-dd]'));
      const set = (item, on) => {
        item.classList.toggle('is-open', on);
        item.querySelector('.mh-util__btn').setAttribute('aria-expanded', on ? 'true' : 'false');
        item.querySelector('.mh-util__dd').hidden = !on;
      };
      this.closeUtil = (except) => this.utilItems.forEach((i) => { if (i !== except) set(i, false); });
      this.utilItems.forEach((item) => {
        const btn = item.querySelector('.mh-util__btn');
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const on = !item.classList.contains('is-open');
          this.closeUtil(item);
          this.close();
          set(item, on);
        });
        if (this.trigger === 'hover') {
          let t;
          item.addEventListener('mouseenter', () => { if (!this.mq.matches) return; clearTimeout(t); this.closeUtil(item); set(item, true); });
          item.addEventListener('mouseleave', () => { if (!this.mq.matches) return; t = setTimeout(() => set(item, false), 200); });
        }
        item.addEventListener('focusout', (e) => { if (e.relatedTarget && !item.contains(e.relatedTarget)) set(item, false); });
      });
      document.addEventListener('click', (e) => { this.utilItems.forEach((i) => { if (!i.contains(e.target)) set(i, false); }); });
    }

    open(item) {
      this.closeUtil && this.closeUtil();
      if (this.current && this.current !== item) this.setItem(this.current, false);
      this.current = item;
      this.setItem(item, true);
      this.classList.add('is-panel-open');
    }

    close() {
      if (this.current) this.setItem(this.current, false);
      this.current = null;
      this.classList.remove('is-panel-open');
    }

    setItem(item, on) {
      item.classList.toggle('is-open', on);
      const btn = item.querySelector('.mh-nav__link');
      const panel = item.querySelector('.mh-panel');
      btn && btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (panel) on ? panel.removeAttribute('inert') : panel.setAttribute('inert', '');
    }

    /* ---------- Mobile drawer ---------- */
    initDrawer() {
      this.drawer = this.querySelector('.mh-drawer');
      this.burger = this.querySelector('.mh-burger');
      if (!this.drawer || !this.burger) return;
      this.root = this.drawer.querySelector('.mh-drawer__root');

      this.burger.addEventListener('click', () => {
        this.classList.contains('is-drawer-open') ? this.closeDrawer() : this.openDrawer();
      });

      this.drawer.querySelectorAll('[data-sub-open]').forEach((b) => {
        b.addEventListener('click', () => this.openSub(b.getAttribute('data-sub-open')));
      });
      this.drawer.querySelectorAll('[data-sub-back]').forEach((b) => {
        b.addEventListener('click', () => this.closeSub());
      });
    }

    updateDrawerTop() {
      const main = this.querySelector('.mh-main');
      if (!main) return;
      let bottom = main.getBoundingClientRect().bottom;
      if (this.classList.contains('is-search-open')) {
        const s = this.querySelector('.mh-msearch');
        if (s) bottom = s.getBoundingClientRect().bottom;
      }
      this.style.setProperty('--mh-drawer-top', Math.max(0, Math.round(bottom)) + 'px');
    }

    openDrawer() {
      this.classList.remove('is-search-open');
      this.updateDrawerTop();
      this.classList.add('is-drawer-open');
      this.drawer.removeAttribute('inert');
      this.burger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('mh-lock');
    }

    closeDrawer() {
      if (!this.drawer) return;
      this.classList.remove('is-drawer-open');
      this.drawer.setAttribute('inert', '');
      this.burger && this.burger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('mh-lock');
      setTimeout(() => this.closeSub(true), 250);
    }

    openSub(id) {
      const sub = this.drawer.querySelector('#' + CSS.escape(id));
      if (!sub) return;
      this.drawer.querySelectorAll('.mh-drawer__sub.is-active').forEach((s) => s.classList.remove('is-active'));
      sub.classList.add('is-active');
      sub.removeAttribute('inert');
      sub.scrollTop = 0;
      this.root && this.root.classList.add('is-shifted');
      const back = sub.querySelector('[data-sub-back]');
      back && setTimeout(() => back.focus({ preventScroll: true }), 320);
    }

    closeSub(silent) {
      if (!this.drawer) return;
      this.drawer.querySelectorAll('.mh-drawer__sub').forEach((s) => { s.classList.remove('is-active'); s.setAttribute('inert', ''); });
      this.root && this.root.classList.remove('is-shifted');
    }

    /* ---------- Search ---------- */
    initSearch() {
      const toggle = this.querySelector('.mh-search-toggle');
      toggle && toggle.addEventListener('click', () => {
        if (this.classList.contains('is-drawer-open')) this.closeDrawer();
        const on = this.classList.toggle('is-search-open');
        toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (on) { const f = this.querySelector('.mh-msearch input'); f && setTimeout(() => f.focus(), 30); }
      });

      // Rotating placeholder: "Cari... Wajan" -> "Cari... Panci"
      this.querySelectorAll('.mh-search__field[data-words]').forEach((input) => {
        const words = input.dataset.words.split(',').map((w) => w.trim()).filter(Boolean);
        const prefix = input.dataset.prefix || '';
        if (!words.length) return;
        let i = 0;
        input.placeholder = prefix + words[0];
        if (words.length < 2) return;
        setInterval(() => {
          if (document.activeElement === input || input.value) return;
          i = (i + 1) % words.length;
          input.placeholder = prefix + words[i];
        }, 2600);
      });

      if (this.dataset.predictive === 'true') {
        this.querySelectorAll('.mh-search').forEach((form, n) => this.initPredictive(form, n));
      }
    }

    /* ---------- Predictive search (saran saat mengetik) ---------- */
    initPredictive(form, n) {
      const input = form.querySelector('.mh-search__field');
      const box = form.querySelector('[data-ps]');
      if (!input || !box) return;

      const listId = 'MhPs-' + (this.id || 'mh') + '-' + n;
      box.id = listId;
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', listId);
      input.setAttribute('aria-expanded', 'false');

      const cache = new Map();
      const limit = parseInt(this.dataset.searchLimit || '4', 10);
      const showPrice = this.dataset.showPrice !== 'false';
      const suggestUrl = (this.dataset.suggestUrl || '/search/suggest') + '.json';
      const searchUrl = this.dataset.searchUrl || '/search';
      const popular = (this.dataset.popular || '').split(',').map((w) => w.trim()).filter(Boolean);
      let timer = null;
      let ctrl = null;
      let active = -1;
      let lastQ = '';

      const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      const mark = (text, q) => {
        const t = esc(text);
        const words = q.trim().split(/\s+/).filter((w) => w.length > 1).map((w) => esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
        if (!words.length) return t;
        return t.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>');
      };
      const money = (val) => this.formatMoney(val);
      // suggest.json: harga berupa string desimal ("1149000.00"); API lain kadang angka dalam sen (114900000)
      const toAmount = (v) => (typeof v === 'number' ? v / 100 : parseFloat(v) || 0);
      const searchHref = (q) => searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      const imgUrl = (src, w) => {
        if (!src) return '';
        try { const u = new URL(src, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; }
      };

      const open = () => {
        if (!this.mq.matches) box.style.setProperty('--mh-ps-top', Math.round(form.getBoundingClientRect().bottom + 10) + 'px');
        box.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        form.classList.add('is-ps-open');
        this.close();
      };
      const close = () => {
        box.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        form.classList.remove('is-ps-open');
        active = -1;
      };
      const options = () => Array.from(box.querySelectorAll('[data-ps-opt]'));
      const setActive = (i) => {
        const opts = options();
        if (!opts.length) return;
        active = (i + opts.length) % opts.length;
        opts.forEach((o, k) => o.classList.toggle('is-active', k === active));
        const el = opts[active];
        input.setAttribute('aria-activedescendant', el.id);
        el.scrollIntoView({ block: 'nearest' });
      };
      const stamp = () => { let k = 0; options().forEach((o) => { o.id = listId + '-o' + k++; o.setAttribute('role', 'option'); }); };

      const renderPopular = () => {
        if (!popular.length) { close(); return; }
        box.innerHTML =
          '<div class="mh-ps__sec"><p class="mh-ps__head">Pencarian populer</p><div class="mh-ps__chips" role="listbox">' +
          popular.map((w) => '<a data-ps-opt class="mh-ps__chip" href="' + searchHref(w) + '">' + esc(w) + '</a>').join('') +
          '</div></div>';
        stamp();
        open();
      };

      const render = (q, r) => {
        const queries = (r.queries || []).filter((x) => x.text.toLowerCase() !== q.toLowerCase()).slice(0, 4);
        const collections = (r.collections || []).slice(0, 3);
        const pages = (r.pages || []).slice(0, 2);
        const products = (r.products || []).slice(0, limit);
        let html = '';

        if (queries.length || collections.length || pages.length) {
          html += '<div class="mh-ps__sec mh-ps__sec--side">';
          if (queries.length) {
            html += '<p class="mh-ps__head">Saran</p><ul role="listbox">' +
              queries.map((x) => '<li><a data-ps-opt class="mh-ps__term" href="' + searchHref(x.text) + '">' + mark(x.text, q) + '</a></li>').join('') + '</ul>';
          }
          if (collections.length) {
            html += '<p class="mh-ps__head">Koleksi</p><ul role="listbox">' +
              collections.map((c) => '<li><a data-ps-opt class="mh-ps__term" href="' + esc(c.url) + '">' + mark(c.title, q) + '</a></li>').join('') + '</ul>';
          }
          if (pages.length) {
            html += '<p class="mh-ps__head">Halaman</p><ul role="listbox">' +
              pages.map((p) => '<li><a data-ps-opt class="mh-ps__term" href="' + esc(p.url) + '">' + mark(p.title, q) + '</a></li>').join('') + '</ul>';
          }
          html += '</div>';
        }

        if (products.length) {
          html += '<div class="mh-ps__sec mh-ps__sec--products"><p class="mh-ps__head">Produk</p><ul role="listbox" class="mh-ps__products">' +
            products.map((p) => {
              const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              const price = toAmount(p.price != null ? p.price : p.price_min);
              const compare = toAmount(p.compare_at_price_max || p.compare_at_price_min || 0);
              const onSale = compare > price;
              const priceHtml = showPrice
                ? '<span class="mh-ps__price">' + (onSale ? '<s>' + money(compare) + '</s> ' : '') + '<b' + (onSale ? ' class="is-sale"' : '') + '>' + money(price) + '</b></span>'
                : '';
              return '<li><a data-ps-opt class="mh-ps__product" href="' + esc(p.url) + '">' +
                '<span class="mh-ps__img">' + (img ? '<img src="' + esc(imgUrl(img, 160)) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</span>' +
                '<span class="mh-ps__info"><span class="mh-ps__title">' + mark(p.title, q) + '</span>' + priceHtml +
                (p.available === false ? '<span class="mh-ps__oos">Stok habis</span>' : '') + '</span></a></li>';
            }).join('') + '</ul></div>';
        }

        if (!html) {
          html = '<div class="mh-ps__empty">Tidak ada hasil untuk “' + esc(q) + '”. Coba kata lain, misalnya <b>' + esc(popular[0] || 'wajan') + '</b>.</div>';
        }
        html += '<a data-ps-opt class="mh-ps__all" href="' + searchHref(q) + '">Lihat semua hasil untuk “' + esc(q) + '” <span aria-hidden="true">→</span></a>';

        box.innerHTML = html;
        box.classList.toggle('has-side', !!(queries.length || collections.length || pages.length) && !!products.length);
        stamp();
        open();
      };

      const run = (q) => {
        if (cache.has(q)) { render(q, cache.get(q)); return; }
        if (ctrl) ctrl.abort();
        ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        form.classList.add('is-ps-loading');
        const params = new URLSearchParams();
        params.set('q', q);
        params.set('resources[type]', 'query,product,collection,page');
        params.set('resources[limit]', String(Math.max(limit, 4)));
        params.set('resources[limit_scope]', 'each');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
        fetch(suggestUrl + '?' + params.toString(), { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
          .then((res) => { if (!res.ok) throw new Error(res.status); return res.json(); })
          .then((data) => {
            const r = (data && data.resources && data.resources.results) || {};
            cache.set(q, r);
            if (input.value.trim() === q) render(q, r);
          })
          .catch((err) => { if (err && err.name === 'AbortError') return; close(); })
          .finally(() => form.classList.remove('is-ps-loading'));
      };

      input.addEventListener('input', () => {
        const q = input.value.trim();
        clearTimeout(timer);
        if (q === lastQ && !box.hidden) return;
        lastQ = q;
        if (q.length < 2) { if (ctrl) ctrl.abort(); q.length ? close() : renderPopular(); return; }
        timer = setTimeout(() => run(q), 220);
      });
      input.addEventListener('focus', () => {
        const q = input.value.trim();
        if (q.length >= 2) run(q); else renderPopular();
      });
      input.addEventListener('keydown', (e) => {
        if (box.hidden) { if (e.key === 'ArrowDown') { input.dispatchEvent(new Event('focus')); e.preventDefault(); } return; }
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
        else if (e.key === 'Enter' && active > -1) { e.preventDefault(); options()[active].click(); }
        else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
      });
      form.addEventListener('submit', (e) => { if (!input.value.trim()) e.preventDefault(); });
      document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
      form.addEventListener('focusout', (e) => { if (!form.contains(e.relatedTarget) && e.relatedTarget) close(); });
    }

    formatMoney(amount) {
      if (isNaN(amount)) return '';
      const fmt = this.dataset.moneyFormat || 'Rp {{amount_no_decimals}}';
      const group = (n, dec, t, d) => {
        const [i, f] = Number(n).toFixed(dec).split('.');
        return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (dec ? d + f : '');
      };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount': return group(amount, 2, ',', '.');
          case 'amount_no_decimals': return group(amount, 0, ',', '.');
          case 'amount_with_comma_separator': return group(amount, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(amount, 0, '.', ',');
          case 'amount_with_space_separator': return group(amount, 2, ' ', ',');
          case 'amount_no_decimals_with_space_separator': return group(amount, 0, ' ', ',');
          case 'amount_with_apostrophe_separator': return group(amount, 2, "'", '.');
          default: return group(amount, 0, ',', '.');
        }
      });
    }

    /* ---------- Cart (Dawn cart drawer compatible) ---------- */
    initCart() {
      const btn = this.querySelector('[data-mh-cart]');
      const countEl = this.querySelector('[data-mh-cart-count]');
      const proxy = document.getElementById('cart-icon-bubble');

      if (btn) {
        btn.addEventListener('click', (e) => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            e.preventDefault();
            this.closeDrawer();
            drawer.open(btn);
          }
        });
      }

      const setCount = (n) => {
        if (!countEl) return;
        n = parseInt(n, 10) || 0;
        countEl.textContent = n > 99 ? '99+' : n;
        countEl.dataset.count = n;
      };

      // Dawn re-renders #cart-icon-bubble after add-to-cart; mirror its number.
      if (proxy && countEl) {
        const read = () => {
          const span = proxy.querySelector('.cart-count-bubble span[aria-hidden="true"]') || proxy.querySelector('.cart-count-bubble span');
          setCount(span ? span.textContent.trim() : 0);
        };
        new MutationObserver(read).observe(proxy, { childList: true, subtree: true, characterData: true });
      }

      // Fallback for themes/apps that dispatch their own cart events
      const refresh = () => fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
        .then((r) => r.json()).then((c) => setCount(c.item_count)).catch(() => {});
      ['cart:updated', 'cart:refresh', 'cart:change'].forEach((ev) => document.addEventListener(ev, refresh));
    }

    /* ---------- Sticky (announcement scrolls away, header sticks) ---------- */
    initSticky() {
      if (this.dataset.sticky !== 'true') return;
      const section = this.closest('.shopify-section') || this;
      const ann = this.querySelector('.mh-ann');
      const apply = () => {
        const h = ann ? ann.offsetHeight : 0;
        section.style.position = 'sticky';
        section.style.top = (-h) + 'px';
        section.style.zIndex = '30';
      };
      apply();
      window.addEventListener('resize', apply, { passive: true });
      window.addEventListener('scroll', () => {
        if (this.classList.contains('is-drawer-open')) this.updateDrawerTop();
      }, { passive: true });
    }
  }

  customElements.define('mega-header', MegaHeader);
})();
